import styled from "styled-components";
import colors from "../../../../css/colors";

export const Wrapper = styled.div`
  margin: 0 0 40px;
`;

export const SectionCard = styled.div`
  background-color: ${colors.WHITE};
  border: 1px solid ${colors.GREY_LIGHT};
  border-radius: 4px;
  max-width: 100%;
  overflow: auto;
`;

export const Table = styled.table`
  width: 100%;
  background-color: ${colors.WHITE};
`;

export const Row = styled.tr`
  &:not(:last-child) {
    border-bottom: 1px solid ${colors.GREY_LIGHT};
  }
`;

export const TableHeader = styled.th`
  padding: 16px;
  color: ${colors.GREY};
  font-weight: 300;
`;

export const Cell = styled.td`
  padding: 16px;
`;

export const EmptyTableWrapper = styled.div`
  padding: 16px;
  text-align: center;
  background: #f7f7f7;
`;

export const NoDataRow = styled.div`
  padding: 16px;
  text-align: center;
  background: #f7f7f7;
`;
